import SearchModal from '@/modules/search-modal';
import Button from '@/components/inputs/button';
import { VARIANT } from '@/components/inputs/button/button.types';
import { VARIANT as ICON_VARIANT } from '@/components/data-display/icon/icon.types';
import Icon from '@/components/data-display/icon';
import { toggleModal } from '@/components/utilities/modal';
import { useMicrocopyContext } from '@/context/microcopy/microcopy-context';
import trackEvent from '@/utils/track-event';
import { EVENT_NAME, USER_ACTION } from '@/utils/track-event/track-event.types';
import styles from './search-box-modal.module.scss';

const SearchBoxModal = () => {
  const microcopy = useMicrocopyContext();
  const modalLabel = 'search-box-modal';

  const handleSearchClick = () => {
    toggleModal(modalLabel);
    trackEvent({
      event: EVENT_NAME.SHOPPING_SEARCH,
      user_action: USER_ACTION.SEARCH_INITIATION,
    });
  };

  return (
    <div className={styles['search-box']} data-testid={modalLabel}>
      <div className={styles['search-box__wrapper']}>
        <Button
          className={styles['search-box__button']}
          variant={VARIANT.Unstyled}
          onClick={handleSearchClick}
        >
          <div className={styles['search-box__icon-wrapper']}>
            <Icon
              variant={ICON_VARIANT.Search}
              className={styles['search-box__icon']}
            />
            <span>{microcopy.general_search_placeholder}</span>
          </div>
        </Button>
        <SearchModal
          modalLabel={modalLabel}
          wasLabel={microcopy.merchant_ratewas}
          upToLabel={microcopy.merchant_rateupto}
          fromLabel={microcopy.merchant_ratefrom}
          title={microcopy.general_search_placeholder}
          noResultsLabel={microcopy.general_search_noresults}
        />
      </div>
    </div>
  );
};
export default SearchBoxModal;
